import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 提交锡康码和14天轨迹图
  userTrackRecordSave(arg) {
    return Axios({
      url: requestPrefix.projectUrl + '/userTrackRecord/save',
      method: 'post',
      data: arg
    })
  },
  // 获取锡康码（苏康码）、14天轨迹图
  userTrackRecordGetByProjectId(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/userTrackRecord/getByProjectId/' + id,
      method: 'get'
    })
  },

  // 查询个人上报温度
  userTemperatureRecordPage(arg) {
    return Axios({
      url: requestPrefix.projectUrl + '/userTemperatureRecord/page',
      method: 'post',
      data: arg
    })
  },
  // 提交个人当天温度
  userTemperatureRecordSave(arg) {
    return Axios({
      url: requestPrefix.projectUrl + '/userTemperatureRecord/save',
      method: 'post',
      data: arg
    })
  },
  // 获取所有人员当日体温列表
  userTemperatureRecordGetListByDate(arg) {
    return Axios({
      url: requestPrefix.projectUrl + '/userTemperatureRecord/getListByDate',
      method: 'post',
      data: arg
    })
  },
  // 根据人员获取锡康码（苏康码）、14天轨迹图
  userTrackRecordGetByUserId(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/userTrackRecord/getByUserId',
      method: 'GET',
      params: args
    })
  },
  // 根据人员获取体温列表
  userTemperatureRecordGetListByUser(arg) {
    return Axios({
      url: requestPrefix.projectUrl + '/userTemperatureRecord/getListByUser',
      method: 'post',
      data: arg
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/Epidemicprevention/index.js